module.exports = __webpack_public_path__ + "static/media/account_icon.ebabf13f.svg";